import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName } from "../../helper/common";
import styles from "./TenantGreeting.module.css";

const TenantGreeting = ({ user }) => {
  const { _t } = useTranslator();
  const name = getUserDisplayName(user, "").split(" ")[0] || user?.fname || "";

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>
        {_t(
          "hiNameHeresYourSkorProfile",
          `Hi ${name}, here's your Skor profile`,
          undefined,
          { name }
        )}
      </h1>
    </div>
  );
};

export default TenantGreeting;
